






























































import { VueConstructor } from 'vue';
import { computed, defineComponent, watch } from '@vue/composition-api';
import PlusButton from '@front-app/components/buttons/PlusButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import { Routes } from '@front-app/constants/routes';
import { isFocusableElement, useAsyncModal } from '@front-app/hooks/useAsyncModal';
import { useIsError, useIsLoading } from '@front-app/hooks/useAsyncStatus';
import AdminProgramCard from '@front-app/modules/learningPrograms/admin/AdminProgramCard.vue';
import { getLearningProgramsStore } from '@front-app/modules/learningPrograms/store/LearningProgramsStore';

const fetchModal = () => import(/* webpackChunkName: "addProgramModal" */'@front-app/modules/learningPrograms/admin/create/CreateProgramStepperPanel.vue')
	.then((_) => _.default as VueConstructor);

export default defineComponent({
	components: {
		AdminProgramCard,
		ErrorCard,
		LoaderState,
		PlusButton,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const programsStore = getLearningProgramsStore();
		watch(computed(() => props.groupId), (curr) => {
			programsStore.fetchGroupPrograms(curr, true, true);
		}, { immediate: true });
		const fetchStatus = computed(() => programsStore.getGroupProgramsStatus(props.groupId).value);
		const isLoading = useIsLoading(fetchStatus);
		const isError = useIsError(fetchStatus);

		const {
			isModalVisible,
			modalView,
			loadModalView,
			showModal,
			closeModal,
		} = useAsyncModal('tmp', fetchModal);
		const startCreateProgramFlow = (e: MouseEvent | KeyboardEvent) => {
			const { currentTarget } = e;
			const focusable = isFocusableElement(currentTarget) ? currentTarget : undefined;
			showModal(focusable);
		};

		const getProgramDOMId = (id: string) => `program_${id}`;

		const showNewProgram = async (programId: string) => {
			// Find the new card
			const newCard = document.getElementById(getProgramDOMId(programId));
			if (isFocusableElement(newCard)) {
				// Set the new card as the focusable element
				await showModal(newCard);
			}
			// Close the tray
			closeModal();
		};

		const toManageProgram = (programId: string) => ({
			name: Routes.GROUP_ADMIN_MANAGE_LEARNING_PROGRAM,
			params: { programId },
		});

		return {
			// Tab load
			isLoading,
			isError,
			toManageProgram,
			getProgramDOMId,
			programs: computed(() => programsStore.getAllGroupPrograms(props.groupId)),
			startCreateProgramFlow,
			// Modal
			loadModalView,
			modalView,
			isModalVisible,
			closeModal,
			showNewProgram,
		};
	},
});
